export default __webpack_public_path__ + "static/media/button-red-up-129x85.f3e92bd4.svg";